import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealService } from '../deal.service';
import { Deal, DealPagedRequest, FlowType } from '../model';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DatePipe } from '@angular/common';
import { OverdueCategoryPipe } from '../pipes/overdue-category.pipe';

@Component({
  selector: 'app-deal-list',
  imports: [
    TableModule, ButtonModule,
    DatePipe, OverdueCategoryPipe
  ],
  templateUrl: './deal-list.component.html',
  styleUrl: './deal-list.component.scss'
})
export class DealListComponent implements OnInit {

  public req: DealPagedRequest = {
    page: 0,
    pageSize: 20,
    type: FlowType.OVERDUE
  };

  protected deals: Deal[] = [];
  protected total: number = 0;
  protected isLoading: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: DealService
  ) {

  }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(url => {
      const path = url[1].path;

      if (path == "ovedues") {
        this.req.type = FlowType.OVERDUE;
      } else if (path == "renewals") {
        this.req.type = FlowType.RENEWAL;
      }
    });
  }

  loadDealsLazy(ev: TableLazyLoadEvent) {
    this.service.list({
      type: this.req.type,
      pageSize: this.req.pageSize,
      page: (ev.first ?? 0) / this.req.pageSize
    }).subscribe(data => {
      this.deals = data.items;
      this.total = data.total;
    });
  }

  edit(item: Deal) {
    console.log('Edit', item);
  }
}
